


import React, { useState } from "react";

const DocketWiseKyc: React.FC = () => {
  const [ticketNo, setTicketNo] = useState("");
  const [show, setShow] = useState(false);

  const files = ["KYC1.png", "KYC2.png"];

  return (
    <div className="text-center">
      {/* Ticket Input */}
      <input
        type="text"
        placeholder="Enter Ticket / AWB No"
        value={ticketNo}
        onChange={(e) => {
          setTicketNo(e.target.value);
          setShow(false);
        }}
        style={{
          padding: "10px",
          width: "280px",
          borderRadius: "6px",
          border: "1px solid #ccc",
        }}
      />

      <br />

      {/* Button */}
      <button
        className="pod-btn-blue mt-3"
        onClick={() => {
          if (!ticketNo.trim()) {
            alert("Please enter Ticket No");
            return;
          }
          setShow(!show);
        }}
      >
        {show ? "Hide KYC Files" : "Show KYC Files"}
      </button>

      {/* KYC ICON LIST */}
      {show && (
        <div className="mt-4 d-flex flex-column align-items-center">
          {files.map((file, i) => {
            const label = file.replace(".png", "");
            const url = `https://jaimarutilogistics.com/wwwroot/${ticketNo}/${file}`;

            return (
              <div
                key={i}
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "260px",
                  padding: "10px",
                  marginBottom: "10px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                }}
              >
                {/* 🖼️ SMALL ICON */}
                <span style={{ fontSize: "22px", marginRight: "10px" }}>
                  🖼️
                </span>

                {/* FILE NAME */}
                <span style={{ flex: 1, fontWeight: 600 }}>{label}</span>

                {/* DOWNLOAD */}
                <a
                  href={url}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-success"
                >
                  Download
                </a>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DocketWiseKyc;
